import React from 'react';

import { styled } from 'styled-components';

import theme from 'styles/theme';

import CtaCard from 'components/CtaCard/CtaCard';
import CtaCardImage from 'components/CtaCard/CtaCardImage';
import InnerHtml from 'components/InnerHtml/InnerHtml';

import { BlogPostSidebarCtaI } from 'interfaces/content-stack/blogPost';

import { getModularBlockLink } from 'utils/modularBlockUtils';

const PromoHeader = styled.div`
  font-weight: 500;
  text-transform: uppercase;
  font-family: ${(props) => props.theme.fonts.fontFamilySecondary};
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
`;

interface PromoCtaProps {
  data: BlogPostSidebarCtaI;
}

const PromoCta: React.FC<PromoCtaProps> = ({ data }) => {
  const { header, imageAltText, image, link, description } = data;

  return (
    <CtaCard
      link={getModularBlockLink(link) ?? ''}
      target='_blank'
      bgColor={theme.colors.white}
      mobileBgColor={theme.colors.whiteSmoke}
      hoverBgColor='none'
      imgComponent={<CtaCardImage imageUrl={image?.url} imageAltText={imageAltText} />}
    >
      {header && <PromoHeader>{header}</PromoHeader>}
      {description && <InnerHtml richText={description} />}
    </CtaCard>
  );
};

export default PromoCta;
